// extracted by mini-css-extract-plugin
export default {"delete":"icons_delete__hHsnM","edit":"icons_edit__xUr3v","stats":"icons_stats__0icvO"};